export const CONTROLS = {
    HEADER: "header",
    PARAGRAPH: "paragraph",
    LABEL: "label",
    MONTH: "month",
    DATE: "date",
    SELECT: "select",
    RADIO: "radio",
    RADIO_BUTTON: "radio-button",
    CHECKBOX: "checkbox",
    EMAIL: "email",
    NUMBER: "number",
    PHONE: "phone",
    PASSWORD: "password",
    SEARCH: "search",
    HINT: "hint",
    MODALSEARCH: "modalsearch",
    FILE: "file",
    MULTITEXT: "multitext",
    MULTISELECT: "multiselect",
    TEXT: "text",
    INPUT_MASK: "input-mask",
    TEXT_FIELD: "text_field",
    TEMPATE: "template",
    TEXT_CUSTOM: "text_custom",
    CURRENCY: "currency"
};
